import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetEventFlowsDto } from '@/types/dtos/flows/response/get-event-flows.dto.ts';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import { masterFlowsForEventList } from '@/helpers/flow-scope.helper';

export const GET_EVENT_FLOWS_QUERY_KEY = 'get-event-flows';

export const normalizeEventFlowsResponse = (flows?: FlowDto[]) => {
  const listFlows = masterFlowsForEventList(flows);
  const planFlows = listFlows.filter((flow) => flow.mode === 'PLAN');
  const organizeFlows = listFlows.filter((flow) => flow.mode === 'ORGANIZE');
  return { planFlows, organizeFlows };
};

type EventFlowsQueryOptions = {
  enabled?: boolean;
};

// Query event flows by originId - backend decides what mode documents to return
export const useGetEventFlowsQuery = (id?: string, options: EventFlowsQueryOptions = {}) => {
  const { getToken } = useAuth();
  const { enabled = true } = options;

  return useQuery({
    queryKey: [GET_EVENT_FLOWS_QUERY_KEY, id],
    queryFn: async () => {
      const token = await getToken();
      return getEventFlows({ id: id!, token: token ?? '' });
    },
    enabled: !!id && enabled,
  });
};

const getEventFlows = async ({ id, token }: { id: string; token: string }): Promise<GetEventFlowsDto> => {
  // Query with originId only - backend provides appropriate document(s) based on access
  const url = `${import.meta.env.VITE_API_URL}/flows/event/${id}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
